module.exports = __webpack_public_path__ + "fonts/NoirPro-Heavy.873c8fa8.woff2";